<template>
  <div 
    class="roleHeader grid-child-items-wrapper max-w-full text-base-content"
    :class="[FIELD_ITEM_GAP_CLASS, {'roleHeader-output': isOutputTab }]"
  >
    <div class="roleHeader__placeholder roleHeader__placeholder--before" /> <!-- Placeholder -->
    <div class="roleHeader__items ml-auto">
      <div
        v-if="!isOutputTab"
        class="roleHeader__item font-semibold text-sm w-24 box-content"
        :class="HEADER_PADDING_X_CLASS"
        :style="columnHeaderStyles"
      >
        {{ $t('pages.check_admin.block_visibility') }}
      </div>
      <div class="grid-child-items-inner">
        <div /> <!-- Placeholder -->
        <div
          v-if="!isOutputTab"
          class="flex w-min text-base-content justify-end"
        >
          <HeaderBlock
            v-for="(role, id) in roles"
            :key="id"
            class="roleHeader__item"
            :style="roleHeaderStyles"
            :title="role"
            :changeUi="changeUi"
            :currentTab="tab"
          />
        </div>
        <div
          v-else
          class="flex gap-4 w-min text-base-content justify-end mr-6"
        >
          <HeaderBlock
            v-for="(role, id) in rolesOutput"
            :key="id"
            class="roleHeader__item"
            :style="roleHeaderStyles"
            :title="role"
            :changeUi="changeUi"
             :currentTab="tab"
          />
        </div>
      </div>
      <div
        v-for="item in columnsAfter"
        :key="item.id"
        class="roleHeader__item font-semibold text-sm box-content"
        :class="HEADER_PADDING_X_CLASS"
        :style="{ width: item.width }"
      >
        {{ item.label }}
      </div>
    </div>
    <!-- Placeholder -->
    <div class="roleHeader__placeholder roleHeader__placeholder--after" />
  </div>
</template>

<script>
import HeaderBlock from "./components/header-block.vue";
import {
  FORM_EDITOR_TYPE_MAP,
  COLUMNS_MAP,
  ROLE_HEADER_WIDTH,
  COLUMN_HEADER_WIDTH,
  DROPDOWN_HEADER_WIDTH,
  HEADER_PADDING_X_CLASS,
  FIELD_ITEM_GAP_CLASS,
  columnHeaderStyles,
} from "../../utils/constants";
import { getHeaderDisplay } from "../../utils";

export default {
  name: 'field-roles-header',
  components: {
    HeaderBlock,
  },
  data() {
    return {
      columnHeaderStyles,
      COLUMNS_MAP,
      HEADER_PADDING_X_CLASS,
      FIELD_ITEM_GAP_CLASS,
      roles: [
        'Analyst',
        'Subject',
        'Client',
        'Referee',
      ],
      rolesOutput: [
        'Analyst',
        'Client',
      ],
      inCheckRole:null
    }
  },
  props:{
    changeUi:{
      type:Boolean,
    },
    tab: {
      type: String
    },
    formEditorSection: {
      type: String,
      default: FORM_EDITOR_TYPE_MAP.DEFAULT,
    },
  },
  computed: {
    roleHeaderStyles() {
      return {
        width: ROLE_HEADER_WIDTH,
      }
    },
    isOutputTab() {
      return this.tab === 'check-output-form-editor';
    },
    columnsAfter() {
      return [
        {
          id: COLUMNS_MAP.CASE_CREATION,
          label: this.$t('pages.check_admin.use_in_case_creation'),
          width: COLUMN_HEADER_WIDTH,
        },
        {
          id: COLUMNS_MAP.BATCH_PROCESSING,
          label: this.$t('pages.check_admin.use_in_batch_processing'),
          width: COLUMN_HEADER_WIDTH,
        },
        {
          id: COLUMNS_MAP.REPORT_VISIBILITY,
          label: this.$t('pages.block_admin.report_visibility'),
          width: DROPDOWN_HEADER_WIDTH,
        },
      ]
        .filter((el) => this.getHeaderDisplay('columns', el.id));
    },
  },
  methods: {
    getHeaderDisplay(headerType, itemToDisplay) {
      return getHeaderDisplay(headerType, itemToDisplay, {
        formEditorType: this.formEditorSection,
      });
    }
  },
}
</script>

<style lang="scss" scoped>
.item-2 {
  margin-right: 6px;
}
.item-1{
  margin-right: 7px;
}
.item-0{
  margin-right: 6px;
}

.grid-child-items-wrapper {
  display: grid;
  grid-template-columns: 100px 1fr 50px;
  grid-auto-flow: column;
  grid-auto-columns: auto;
}

.grid-child-items-inner {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
}

.roleHeader-output {
  padding-left: 110px;
}

.roleHeader {
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  &__items {
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: auto;
  }
  &__placeholder {
    &--before {
      min-width: 800px; // min shift for headers
    }
  }
}
</style>
